// @flow

import FormFileInput from './FormFileInput'

export default FormFileInput
